import {IHouseBooster} from "../../types/booster_generic/IHouseBooster";
import {IBoosterBigDataType} from "../../types/IBoosterBigDataType";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {personTextPluralize, viewsTextPluralize} from "../../utils/texts/pluralize";

export const houseBDViewsLast3daysBooster: IHouseBooster = {
    category: IBoosterCategory.BigDataStats,
    type: IBoosterBigDataType.ViewsLast3Days,

    isValid(params) {
        return !!params.property.boosters_bigdata_stats?.views_last_3_days && params.property.boosters_bigdata_stats?.views_last_3_days > 0;
    },

    getSegments(params) {
        const views = params.property.boosters_bigdata_stats?.views_last_3_days;

        if (!views) {
            return null;
        }

        return [
            "Ten dom",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${viewsTextPluralize(+views)} ${views} ${personTextPluralize(+views)}`
            },
            "w ciągu ostatnich 3 dni."
        ];
    }
};
import {IHouseBooster} from "../../types/booster_generic/IHouseBooster";
import {IBoosterBigDataType} from "../../types/IBoosterBigDataType";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {personTextPluralize, viewsTextPluralize} from "../../utils/texts/pluralize";

export const houseBDViewsLast3daysBooster: IHouseBooster = {
    category: IBoosterCategory.BigDataStats,
    type: IBoosterBigDataType.ViewsLast3Days,

    isValid(params) {
        return !!params.property.boosters_bigdata_stats?.views_last_3_days && params.property.boosters_bigdata_stats?.views_last_3_days > 0;
    },

    getSegments(params) {
        const views = params.property.boosters_bigdata_stats?.views_last_3_days;

        if (!views) {
            return null;
        }

        return [
            "Ten dom",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${viewsTextPluralize(+views)} ${views} ${personTextPluralize(+views)}`
            },
            "w ciągu ostatnich 3 dni."
        ];
    }
};
